import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { UserService } from './user.service';

@Injectable()
export class ValidationsService {
  
    urlValidations: string = `${environment.api}`;

    constructor(
        private _http: HttpClient,
        private _userService: UserService
    ) {}

    getDashboard() { return this._http.get(`${this.urlValidations}/auth/dashboard`, this._userService.httpOptions() ); }

    getDashboard2(ano: number, mes: number, empresa: string) { return this._http.get(`${this.urlValidations}/auth/dashboard2?ano=${ano}&mes=${mes}&empresa=${empresa}`, this._userService.httpOptions()); }

    findRegistrations(dni: number, gender: string, alerts) { return this._http.get(`${this.urlValidations}/auth/buscarregistraciones?${dni?'dni='+dni:''}&sexo=${gender}${alerts?'&alerts=1':''}`, this._userService.httpOptions()); }

  downloadValidations(queryParams: string) {
        const token = localStorage.getItem('tivtk');
        let httpOptions = {
            headers: new HttpHeaders({
                'token': token ? token : ''
            }),
            responseType: 'blob' as 'arraybuffer'
        };
        return this._http.get(`${this.urlValidations}/auth/downloadValidation?${queryParams}`, httpOptions);
    }

    uploadValidation(file: File) {
        let formData: FormData = new FormData();
        formData.append("file", file);
        return this._http.post(`${this.urlValidations}/auth/upload`, formData, this._userService.httpOptions());
    }

    getValidation() { return this._http.get(`${this.urlValidations}/auth/getValidation`, this._userService.httpOptions()); }

    findValidations(dni: number, gender: string, alerts) { return this._http.get(`${this.urlValidations}/auth/buscarvalidaciones?dni=${dni}&sexo=${gender}${alerts?'&alerts=1':''}`, this._userService.httpOptions()); }

  manuallyRegister(images: object) { return this._http.post(`${this.urlValidations}/auth/manuallyregister`, images, this._userService.httpOptions()); }

  updateContact(contact: object) { return this._http.post(`${this.urlValidations}/auth/updateContact`, contact, this._userService.httpOptions()); }

  getUsersRegister() { return this._http.get(`${this.urlValidations}/auth/getRegister`, this._userService.httpOptions()); }

  getUsersRegisterErrors(dni ){
    if(dni) return this._http.get(`${this.urlValidations}/auth/errors?dni=` + dni, this._userService.httpOptions()); 
    return this._http.get(`${this.urlValidations}/auth/errors`, this._userService.httpOptions()); 
  }

  imgRegister(cuil: number) { return this._http.get(`${this.urlValidations}/auth/imgregistracion?cuil=${cuil}`, this._userService.httpOptions()); }

  imgRegisterError(dni: number, sexo: String) { return this._http.get(`${this.urlValidations}/auth/errorsImages?dni=${dni}&sexo=${sexo}`, this._userService.httpOptions()); };

  downloadLastRegister() {
      const token = localStorage.getItem('tivtk');
      let httpOptions = {
        headers: new HttpHeaders({
          'token': token ? token : ''
        }),
        responseType: 'blob' as 'arraybuffer'
      };
      return this._http.get(`${this.urlValidations}/auth/downloadRegister`, httpOptions);
    }


    setNotificationsEnabled(id, enabled){
      return this._http.post(`${this.urlValidations}/auth/updateNotificaciones`, {cuil: id, notificaciones: enabled}, this._userService.httpOptions()); 
    }


    setFallecido(id, enabled){
      return this._http.put(`${this.urlValidations}/auth/updateFallecido`, {cuil: id, fallecido: enabled}, this._userService.httpOptions()); 
    }


    findPayments(cuil){
      return this._http.get(`${this.urlValidations}/auth/payments?cuil=` + cuil, this._userService.httpOptions()); 
    }

}
